export const LIST_TYPES = {
    SUBCATEGORIES: 'subcategories',
    FILTERS: 'filters',
};
